"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILGradingTaskBar = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_button_common_1 = require("../il-button/il-button.common");
var il_task_icon_1 = require("./il-task.icon");
function ILGradingTaskBar(_a) {
    var sx = _a.sx, className = _a.className, disabled = _a.disabled, amount = _a.amount, children = _a.children, gradingAction = _a.gradingAction, _b = _a.showGradingTaskButton, showGradingTaskButton = _b === void 0 ? false : _b;
    var classes = 'il-grading-task-bar ' + className;
    var theme = (0, material_1.useTheme)();
    var text = 'No Grading Tasks';
    if (amount) {
        if (amount > 1) {
            text = "".concat(amount, " Grading Tasks");
        }
        if (amount === 1) {
            text = "".concat(amount, " Grading Task");
        }
    }
    function onClick() {
        gradingAction && gradingAction();
    }
    return (react_1.default.createElement(material_1.Box, { className: classes, sx: __assign({ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', justifyContent: 'space-between', gap: '0.2rem', mx: { xs: '0.5rem', sm: '1rem', md: '0.5rem', lg: '1rem' } }, sx) },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'nowrap',
                gap: { md: '0.2rem', lg: '0.5rem' },
            } },
            react_1.default.createElement(il_task_icon_1.ILTaskIcon, { color: disabled ? theme.palette.action.disabled : theme.palette.primary.main }),
            children || (react_1.default.createElement(material_1.Box, { color: disabled ? 'action.disabled' : 'primary.dark' },
                react_1.default.createElement(material_1.Typography, { sx: { fontSize: { xs: '80%', sm: '100%', fontWeight: 'bolder' } } }, text)))),
        showGradingTaskButton && !!amount && (react_1.default.createElement(il_button_common_1.ContainedButton, { size: enums_1.SizeEnum.SMALL, sx: { borderRadius: '25px' }, onClick: onClick },
            react_1.default.createElement(material_1.Box, { sx: { fontSize: { xs: '90%', sm: '100%' } } }, "Grading Tasks")))));
}
exports.ILGradingTaskBar = ILGradingTaskBar;
